module.exports = __webpack_public_path__ + "70cfaab4866d5bb5135789ac201f9fac.jpg";